module.exports = __webpack_public_path__ + "static/media/mathis.32258b56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/LandingPage/images/mathis.jpg
// module id = 1444
// module chunks = 0